<google-map height="{{height}}" width="100%" [center]="center" [zoom]="zoom" class="mno_map_cont">
    <map-marker *ngFor="let marker of markersWithCount" [position]="marker?.latlng" (mapClick)="dispatchEvent(marker)"
                      [title]="marker?.label" [label]="marker?.count">
                  </map-marker>
</google-map>

